import React, {  useContext, useState } from 'react'
import TextField from "../Form/TextField";
import EmailField from "../Form/EmailField";
import PasswordFiled from "../Form/PasswordField";
import SubmitField from "../Form/SubmitField";
import { useFormik } from 'formik';
import * as yup from 'yup';
// import { rootContexts } from "../../contexts/rootContexts";
import { Link } from "react-router-dom";
import CountryField from '../Form/CountryField';
import { signupService } from '../../services/authServices';
import { countryValidation, emailValidation, firstNameValidation, genderValidation, lastNameValidation, passwordValidationsignup } from '../../utils/validation';
import { rootContexts } from '../../contexts/rootContexts';

import errorModel from '../Errors/ErrorModel';

export default function Signup() {
    const [loader,setLoader]=useState(false);
    const { setAsLogin } = useContext(rootContexts);

    const formik = useFormik({
        initialValues: {
            email:"",
            password:"",
            cpassword:"",
            fname:"",
            lname:"",
            role:"User",
            gender:"",
            country:"",
            
            //creationDate:
        },
        validationSchema: yup.object({
          email:emailValidation,
          password:passwordValidationsignup,
          fname:firstNameValidation,
          lname:lastNameValidation,
          gender:genderValidation,
          country:countryValidation,
       
          cpassword:yup.string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required('Please confirm your password')
          
        }),
        onSubmit: async (values) => {
            setLoader(true);
          
            console.log("the values are: " , values)
           const result = await signupService(values);

            console.log("the result is",result)
           if(result.status===true){
            errorModel('success',result.message)
            setAsLogin(false)
            setLoader(false);
          }
            else{
             
              setLoader(false);
              
              errorModel('error',`An account with this email address already exists`)
              // errorModel('error',result.message)
            }
        },
      });
    
  return (
    <>
     <div className=" border-2 border-beta p-4 rounded mt-5">
                    <h1 className="h2 text-center py-4">Create Account</h1>

                    <form onSubmit={formik.handleSubmit} className="px-5 md:px-10 space-y-3">
                      <div className="grid grid-cols-2 gap-y-0 gap-x-4 ">
                        <div>
                        





                          <TextField
                            name="fname"
                            placeholder="First Name"
                            formik={formik}
                          />
                        </div>
                        <div>
                          <TextField
                            name="lname"
                            placeholder="Last Name"
                            formik={formik}
                          />
                        </div>
                      
                      </div>
                      <EmailField
                        name="email"
                        placeholder="Email"
                        formik={formik}
                      />
                      
                      <PasswordFiled
                        name="password"
                        placeholder="Password"
                        formik={formik}
                      />
                      
                      <PasswordFiled
                        name="cpassword"
                        placeholder="Confirm Password"
                        formik={formik}
                      />
                      <div className="">
                      <CountryField
                        name="country"
                        placeholder="Confirm Password"
                        formik={formik}
                      />
                      </div>
                      <div className="py-1 font-imprima text-lg">
                        <div className="flex items-center text-info gap-x-4">
                          <label>Gender</label>
                          <div className="space-x-1">
                            <input
                              type="radio"
                              name="gender"
                              id="male"
                              value="male"
                         
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="border-2 border-black checked:bg-black checked:ring-black"
                            />
                            <label htmlFor="male">Male</label>
                          </div>
                          <div className=" space-x-3">
                            <input
                              type="radio"
                              name="gender"
                              id="female"
                              value="female"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="border-2 border-black checked:bg-black checked:ring-black"
                            />
                            <label htmlFor="female">Female</label>
                          </div>
                        </div>
                        {formik.touched.gender && formik.errors.gender && (
          <div className=" pt-3 text-[12px] text-red-600 font-imprima">
           {formik.errors.gender}
          </div>
        )}
                      </div>
                      <div className="py-1 font-imprima flex items-center space-x-4">
                      
                      
                            <input
                              type="checkbox"
                              name="terms"
                              id="terms"
                           
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className="bg-[#E4E6E3] border-2 border-beta checked:bg-beta checked:ring-beta px-3 py-3"
                              required
                            />
                            <label htmlFor="terms text-info">
                              I agree to <Link to="/terms-and-condition" className="underline"> Terms and Conditions</Link> </label>




                      </div>
                      {formik.touched.terms && formik.errors.terms && (
          <div className=" pt-3 text-[12px] text-red-600 ">
           {formik.errors.terms}
          </div>
        )}
                      <div className=" py-2">
                       
                        <SubmitField label="Register" loader={loader} />
                       
                      </div>
                    </form>
                  </div>
    </>
  )
}
